import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useProfileState = () => React.useContext(Context)
export const useProfile = () => useProfileState()?.profile

const QUERY = gql`
  query Profile($id: ID) {
    profile(id: $id) {
      id
      name
      label
    }
  }
`

const ProfilesLoader = ({ children }) => {
  const id = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: accountsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ProfilesLoader
